/**
 * 接口域名的管理
 */
const base = {
  url: process.env.VUE_APP_BASE_API,
  url_im: process.env.VUE_APP_BASE_API,
  url_nm: process.env.VUE_APP_CLOUD_API
}

export default base
